export default __webpack_public_path__ + "static/gear-4c55d59364d2b69d03b6b3dfd892471a.jpg";